import React from "react";

const CheckBold = () => (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.30502 10.985L1.27002 6.95002L2.00401 6.21602L5.30402 9.51602L13.321 1.49902L14.055 2.23302L5.30502 10.985Z" fill="white" stroke="white" strokeWidth="1.6"/>
    </svg>
);

export default CheckBold;